//Enums:
//Contracts:
import { particles } from 'app/contracts/Particles';
import ParticleBehaviourLookup from './ParticleBehaviourLookup';

export class ParticleManager {
	private _container: PIXI.Container;
	private _sceneProps: particles.SceneProps;
	private _particles: Array<particles.Particle> = [];
	private _fields: Array<particles.ParticleField> = [];

	constructor(sceneProps: particles.SceneProps, container: PIXI.Container) {
		//Create particle sets:
		this._sceneProps = sceneProps;
		this._container = container;
	}

	//GETTER / SETTER
	//--------------------------------------------------------------------------------------------
	public get particles(): Array<particles.Particle> {
		return this._particles;
	}

	//PUBLIC METHODS
	//---------------------------------------------------------------------------------------------
	//(annotation was the v4-era PIXI.particles.ParticleContainer; the only caller
	//passes a plain PIXI.Container, matching the _container field)
	public setContainer(container: PIXI.Container): void {
		this._container = container;
	}

	public resize(): void {
		this._particles.forEach((particle) => particle.resize());
		this._fields.forEach((field) => field.resize());
	}

	public tick(): void {


		for (let i = 0, n = this._fields.length; i < n; i++) {
			this._fields[i].tick();
		}
	}

	public destroy(): void {
		this._particles.forEach((particle) => particle.destroy());
		this._fields.forEach((field) => field.destroy());
	}

	public sortDepth(): void {
		//Reorder the children in the container by their depth:
		this._container.children.sort((a: any, b: any) => {
			if (a.z < b.z) return -1;
			else if (a.z > b.z) return 1;
			return 0;
		});
	}

	public getFieldById(id: string): particles.ParticleField {
		let matchedField: particles.ParticleField = null;

		this._fields.forEach((field) => {
			if (field.id === id) {
				matchedField = field;
			}
		});

		return matchedField;
	}

	public addParticle<T extends particles.Particle>(
		classname: { new (s: particles.SceneProps, c: PIXI.Container, config: particles.ParticleConfig): T },
		config: particles.ParticleConfig,
		container: PIXI.Container = null
	): T {
		let targetContainer: PIXI.Container = container || this._container;
		let particle: T = new classname(this._sceneProps, targetContainer, config);
		ParticleBehaviourLookup.addParticle(particle, particle.active);
		this._particles.push(particle);
		return particle;
	}

	//Register an externally-constructed particle (e.g. from a field's
	//config.particleFactory). Same bookkeeping as addParticle after construction:
	public addParticleInstance<T extends particles.Particle>(particle: T): T {
		ParticleBehaviourLookup.addParticle(particle, particle.active);
		this._particles.push(particle);
		return particle;
	}

	public addField<T extends particles.ParticleField>(
		classname: { new (s: particles.SceneProps, c: PIXI.Container, config: particles.ParticleFieldConfig): T },
		config: particles.ParticleFieldConfig
	): T {
		let field: T = new classname(this._sceneProps, this._container, config);
		this._fields.push(field);
		return field;
	}
}
